import {
  ScaleOrdinal,
  scaleQuantize,
  ScaleQuantize,
  ScaleThreshold,
} from 'd3-scale';
import { createContext } from 'react';

export const HoneycombBaseScaleContext = createContext<
  | ScaleQuantize<string>
  | ScaleThreshold<number, string>
  | ScaleOrdinal<string, string, string>
>(scaleQuantize<string>());
